// extracted by mini-css-extract-plugin
export default {"DescriptionCell":"materials_DescriptionCell__5tYex","NotesIconBox":"materials_NotesIconBox__Y1g6+","BalanceCell":"materials_BalanceCell__tkgCa"};